/* * 分类页面 * 作者：马军 */
<template>
  <div class="search-page">
    <!-- 搜索区域 -->
    <div class="search-top" ref="searchTop">
      <div class="search-box">
        <SearchInputBox :searchFirstKey="searchData.searchWords" :isFirstBlockTheme="false" @onInputSearched="onInputSearched" @onHashChange="onHashChange" />
      </div>
      <ul class="saerch-filter-box jrm-border-1px jrm-border-bottom">
        <li @click="onClickSales" :class="{ 'active-2': salesSort === '1', 'active-1': salesSort === '2' }" clstag="jr|keycount|8530052_claassify_results_sort|salesvolume">
          销量
          <!-- <div class="arrow-box">
            <span class="arrow-top arrow-double-top"></span>
            <span class="arrow-bottom arrow-double-bottom"></span>
          </div>-->
        </li>
        <li :class="{ active: hasAllSelectd }" clstag="jr|keycount|8530052_claassify_results_sort|comment">
          <div @click="onClickALL">{{ allDisplayName }}</div>
          <div class="arrow-box" @click="onClickOpenFilterActionSheet">
            <span class="arrow-trigger-event"></span>
            <span class="arrow-top arrow-all" clstag="jr|keycount|8530052_claassify_results_sort|newproduct" :class="{ 'arrow-close': !filterActionSheetIsShow }"></span>
          </div>
        </li>
        <li @click="onClickPrice" :class="{ 'active-1': priceSort === '1', 'active-2': priceSort === '2' }" clstag="jr|keycount|8530052_claassify_results_sort|pricebydesc">
          价格
          <div class="arrow-box">
            <span class="arrow-top arrow-double-top"></span>
            <span class="arrow-bottom arrow-double-bottom"></span>
          </div>
        </li>
        <li @click="onClickScreeningSwipeLeft" clstag="jr|keycount|8530052_claassify_results_sort|filter">
          筛选
          <div class="arrow-box">
            <span class="filter-icon"></span>
          </div>
        </li>
      </ul>
    </div>
    <!-- 搜索内容 -->
    <div class="search-main">
      <div class="search-main-scroll">
        <BusCardList
          ref="busCardList"
          class="tran"
          :isCreatedLoadData="true"
          :data="goodsLists"
          :hasMoreData="hasMoreData"
          :eventId="'MInterestFree_SearchPro'"
          v-if="goodsLists && goodsLists.length"
          :hasZongjia="true"
          @onMoreElementInView="onMoreElementInView"
        />
        <div v-else-if="hasSearched" class="searched-emtpy">
          <img src="https://img12.360buyimg.com/jrpmobile/jfs/t30412/316/398916078/39034/f9183cb/5bf28208N9df1ad48.png" alt />
          <p class="emtpy-tips">抱歉，没有找到相关商品</p>
        </div>
      </div>
    </div>

    <ToolsFixed :hasHomeIcon="hasHomeIcon" />

    <FilterActionSheet
      ref="fliterActionSheet"
      :isShow="filterActionSheetIsShow"
      :height="filterActionSheetHeight"
      :top="filterActionSheetTop"
      :filterList="filterList"
      @onClickFilter="onClickFilterActionSheet"
      @onClickMask="onClickMask"
    />

    <ScreeningBox ref="screengingBox" :searchData="searchData" @onClickScreeningBox="onClickScreeningBox" @showed="onScreeningBoxShowed" @hided="onScreeningBoxHided" />
  </div>
</template>

<script>
import ScrollView from '@/components/ScrollView.vue';
import BusCardList from '@/buscomponents/BusCardList.vue';
import SearchInputBox from '@/buscomponents/search/SearchInputBox.vue';
import FilterActionSheet from '@/buscomponents/search/FilterActionSheet.vue';
import ToolsFixed from '@/buscomponents/search/ToolsFixed.vue';
import request from '@/util/request';
import { delay, genLinkBySSR } from '@/util/common';
import { getQuery } from '@/util/url';
import { toSearchPage, searchTrim } from '@/util/searchUtil';
import { shareInit } from '@/util/share';
import { messages } from '@/config';
import ScreeningBox from '@/buscomponents/search/ScreeningBox.vue';

let hasHomeIcon = false;
if ($ && $.device && ($.device.jdjr || $.device.jdapp)) {
  hasHomeIcon = false;
}

if (process.env.VUE_APP_ENV === 'dev') {
  hasHomeIcon = true;
}

const ENUMSORTTYPE = {
  // 1.综合排序 composite
  zonghe: 'composite',
  // 2.新品排序 shelvesDt
  xinpin: 'shelvesDt',
  // 3.评论数排序 comment
  pingln: 'comment',
  // 4.销量排序 sale
  xiaoliang: 'sale',
  // 5.价格排序 price
  jiage: 'price'
};
const MappingQueryStringAndSearchData = {
  // 搜索词，不能为空
  sk: 'searchWords',
  // 商品类型，Y：自营，N：POP @崇挺
  dt: 'dataType',
  // 是否可3期免息，1：是，0：否 @崇挺
  is3q: 'is3qmx',
  // 是否可6期免息，1：是，0：否 @崇挺
  is6q: 'is6qmx',
  // 是否可12期免息，1：是，0：否 @崇挺
  is12q: 'is12qmx',
  // 是否可24期免息，1：是，0：否 @崇挺
  is24q: 'is24qmx',
  // 一级分类编码列表 @崇挺
  fcl: 'firstCateList',
  // 二级分类编码列表 @崇挺
  scl: 'secondCateList',
  // 三级分类编码列表 @崇挺
  tcl: 'thirdCateList',
  // 品牌编码列表 @崇挺
  bcl: 'brandCateList',
  // 搜索起始价格 @崇挺
  sp: 'startPrice',
  // 搜索结束价格 @崇挺
  ep: 'endPrice',
  // 排序类型
  st: 'sortType',
  // 排序 默认倒序排列
  // ps: 'sort',
  // 省级编号
  pid: 'provinceId',
  // 市级编号
  cid: 'cityId',
  // 县级编号
  coid: 'countyId',
  // 镇级编号
  tid: 'townId',
  // 过滤地址
  fua: 'fullAddress'
};
export default {
  name: 'SearchPage',
  components: {
    ScrollView,
    BusCardList,
    SearchInputBox,
    FilterActionSheet,
    ScreeningBox,
    ToolsFixed
  },
  data() {
    return {
      hasHomeIcon,
      // 轮询计算次数
      pollCounter: 0,
      hasSearched: false,
      isShowToTop: false,
      filterActionSheetIsShow: false,
      filterActionSheetHeight: '100%',
      filterActionSheetTop: '0',
      hasMoreData: true,
      hasAllSelectd: false,
      allDisplayName: '',
      filterList: [
        // {
        //   name: '综合排序',
        //   displayName: '综合',
        //   key: ENUMSORTTYPE.zonghe,
        //   selected: false
        // },
        {
          name: '评论数从高到低',
          displayName: '评论',
          key: ENUMSORTTYPE.pingln,
          selected: false,
          clstag: 'jr|keycount|jdjr_search_page|pinglun'
        },
        {
          name: '新品优先',
          displayName: '新品',
          key: ENUMSORTTYPE.xinpin,
          selected: false,
          clstag: 'jr|keycount|jdjr_search_page|xinpin'
        }
      ],
      goodsLists: [],
      priceSort: '',
      salesSort: '',

      searchData: {
        // 搜索词，不能为空
        searchWords: '',
        // 商品类型，Y：自营，N：POP @崇挺
        dataType: '',
        // 是否可3期免息，1：是，0：否 @崇挺
        is3qmx: '',
        // 是否可6期免息，1：是，0：否 @崇挺
        is6qmx: '',
        // 是否可12期免息，1：是，0：否 @崇挺
        is12qmx: '',
        // 是否可24期免息，1：是，0：否 @崇挺
        is24qmx: '',
        // 一级分类编码列表 @崇挺
        firstCateList: '',
        // 二级分类编码列表 @崇挺
        secondCateList: '',
        // 三级分类编码列表 @崇挺
        thirdCateList: '',
        // 筛选使用 @崇挺
        matchFirstCtgyCds: [],
        matchSecondCtgyCds: [],
        matchThirdCtgyCds: [],
        // 品牌编码列表 @崇挺
        brandCateList: '',
        // 搜索起始价格 @崇挺
        startPrice: '',
        // 搜索结束价格 @崇挺
        endPrice: '',
        // 省级编号
        provinceId: '',
        // 市级编号
        cityId: '',
        // 县级编号
        countyId: '',
        // 镇级编号
        townId: '',
        fullAddress: '',
        sortType: '',
        sort: '',
        searchCursor: ''
      }
    };
  },
  methods: {
    // 回到顶部
    onToTopPage() {
      this.isShowToTop = false;
      this.$nextTick(() => {
        if (this.$refs && this.$refs.scrollViewSearch) {
          this.$refs.scrollViewSearch.scrollTo(0, 0);
        }
      });
    },
    processToTop(y) {
      const _y = Math.abs(y);
      if (_y >= window.innerHeight) {
        this.isShowToTop = true;
      } else {
        this.isShowToTop = false;
      }
    },
    onScroll({ y }) {
      this.processToTop(y);
    },
    scrollEnd({ y }) {
      this.processToTop(y);
    },
    onMoreElementInView() {
      this.requestSearchData();
    },
    onClickALL() {
      if (this.filterList && this.filterList.length) {
        this.filterList.map(item => {
          if (this.allDisplayName === item.displayName) {
            item.selected = true;
            this.hasAllSelectd = true;
            this.allDisplayName = item.displayName;
            this.searchData.sortType = item.key;
          } else {
            item.selected = false;
          }
        });
      }
      this.searchByLocationHref();
    },
    onClickPrice() {
      this.searchData.sortType = ENUMSORTTYPE.jiage;
      if (this.priceSort === '1') {
        this.priceSort = '2';
      } else {
        this.priceSort = '1';
      }
      this.searchByLocationHref();
    },
    onClickSales() {
      this.searchData.sortType = ENUMSORTTYPE.xiaoliang;
      this.salesSort = '1';

      this.searchByLocationHref();
    },
    onClickOpenFilterActionSheet() {
      const top = $(this.$refs.searchTop).height();
      const height = $(document).height() - top;
      if (height && top) {
        this.filterActionSheetHeight = `${height}px`;
        this.filterActionSheetTop = `${top}px`;
      }

      this.filterActionSheetIsShow = !this.filterActionSheetIsShow;
    },
    onClickMask() {
      this.filterActionSheetIsShow = false;
    },
    onClickFilterActionSheet(filterList, item) {
      this.filterActionSheetIsShow = false;

      this.filterList = filterList;
      this.searchData.sortType = item.key;
      this.searchByLocationHref();
    },
    onClickScreeningSwipeLeft() {
      if (this.goodsLists && this.goodsLists.length === 0 && process.env.VUE_APP_ENV !== 'dev') {
        this.$toast.show('抱歉，暂无合适结果，请适当缩少筛选项再尝试');
        return;
      }

      if (this.$refs && this.$refs.screengingBox) {
        this.$refs.screengingBox.show();
      }

      this.filterActionSheetIsShow = false;
    },
    // 筛选完通知
    onClickScreeningBox(data) {
      Object.assign(this.searchData, data);
      this.searchByLocationHref();
    },
    onInputSearched({ searchKey }) {
      this.searchData.searchWords = searchKey;

      this.searchByLocationHref();
    },
    onHashChange() {
      this.shareInit();
    },
    searchByLocationHref() {
      const params = {};

      for (const key in MappingQueryStringAndSearchData) {
        if (MappingQueryStringAndSearchData.hasOwnProperty(key)) {
          const key1 = MappingQueryStringAndSearchData[key];
          if (this.searchData[key1]) {
            params[key] = this.searchData[key1];
          }
        }
      }

      // 价格排序
      if (this.priceSort !== '') {
        params.ps = this.priceSort;
      }

      toSearchPage(params);
    },
    // 搜索商品
    requestSearchData() {
      if (this.lockRequestLoading || !this.hasMoreData) {
        return;
      }
      this.lockRequestLoading = true;

      if (process.env.VUE_APP_ENV !== 'dev') {
        this.$loading.show();
      }

      request.searchEnjoySku({
        // 参数
        data: this.getQueryData(),
        // 成功
        success: ({ recommendGoodsList, searchCursor, isEnd, matchFirstCtgyCds, matchSecondCtgyCds, matchThirdCtgyCds }) => {
          delay(() => {
            this.lockRequestLoading = false;
          }, 100);
          this.searchData.searchCursor = searchCursor;
          if (false === isEnd && recommendGoodsList && recommendGoodsList.length === 0 && this.pollCounter < 10) {
            this.pollCounter += 1;
            delay(() => {
              this.requestSearchData();
            }, 110);
          } else {
            this.$loading.hide();
            this.pollCounter = 0;
            this.hasMoreData = !isEnd;
            this.searchData.matchFirstCtgyCds = matchFirstCtgyCds;
            this.searchData.matchSecondCtgyCds = matchSecondCtgyCds;
            this.searchData.matchThirdCtgyCds = matchThirdCtgyCds;

            if (recommendGoodsList && recommendGoodsList.length) {
              this.goodsLists = this.goodsLists.concat(recommendGoodsList);
            }
            this.hasSearched = true;
          }
        },
        // 接口失败
        afterError: () => {
          delay(() => {
            this.lockRequestLoading = false;
          }, 100);
        }
      });
    },
    getQueryData() {
      const rst = {};
      for (const key in this.searchData) {
        if (this.searchData.hasOwnProperty(key)) {
          const value = this.searchData[key];
          if (typeof value === 'string' && value !== '') {
            rst[key] = value;
          }
        }
      }

      rst.searchWords = searchTrim(rst.searchWords);

      if (!rst.sort) {
        rst.sort = 'DES';
      }

      return rst;
    },
    shareInit() {
      try {
        const defaultOption = {
          shareURL: genLinkBySSR(),
          shareImgSrc: 'https://img12.360buyimg.com/jrpmobile/jfs/t28069/118/1531685442/19730/8e0317ae/5ce36be5Nf2ce9f2c.png',
          shareTitle: messages.shareTitle,
          shareDesc: messages.shareDesc,
          shareChannels: ['0', '1', '3']
        };
        shareInit(defaultOption);
      } catch (error) {
        console.log(error);
      }
    },
    onScreeningBoxShowed() {
      this.overFlowHidden();
    },
    onScreeningBoxHided() {
      this.overFlowAuto();
    },
    overFlowHidden() {
      $('body').css({ overflow: 'hidden' });
    },
    overFlowAuto() {
      $('body').css({ overflow: '' });
    }
  },
  created() {
    this.shareInit();

    const qs = getQuery();
    if (qs && this.searchData) {
      for (const key in MappingQueryStringAndSearchData) {
        if (MappingQueryStringAndSearchData.hasOwnProperty(key)) {
          const key1 = MappingQueryStringAndSearchData[key];
          if (qs[key]) {
            this.searchData[key1] = qs[key];
          }
        }
      }

      if (!this.searchData.sortType) {
        this.searchData.sortType = ENUMSORTTYPE.xiaoliang;
      }

      switch (this.searchData.sortType) {
        case ENUMSORTTYPE.jiage:
          this.priceSort = qs.ps || '';
          this.searchData.sort = this.priceSort === '1' ? 'ASC' : 'DES';
          break;
        case ENUMSORTTYPE.xiaoliang:
          this.salesSort = '1';
          break;
        default:
          if (this.filterList && this.filterList.length) {
            this.filterList.map(item => {
              if (this.searchData.sortType === item.key) {
                item.selected = true;
                this.hasAllSelectd = true;
                this.allDisplayName = item.displayName;
              } else {
                item.selected = false;
              }
            });
          }
          break;
      }

      if (!this.hasAllSelectd && this.filterList[0]) {
        this.allDisplayName = this.filterList[0].displayName;
      }
    }

    // $(document).on('touchmove', function(e) {
    //   e.preventDefault();
    // });
  },
  mounted() {
    this.requestSearchData();
  },
  watch: {
    filterActionSheetIsShow() {
      if (this.filterActionSheetIsShow) {
        this.overFlowHidden();
      } else {
        this.overFlowAuto();
      }
    }
  },
  destroyed() {
    this.$refs = null;
    this._self = null;
  }
};
</script>

<style lang="scss" scoped>
@import './../scss/mixin.scss';

$search-box-height: $rem68 + $rem20;
$saerch-filter-box-height: $rem100;
.search-page {
  width: 100%;
  &.hidden {
    height: 100%;
    overflow: hidden;
  }
  .search-top {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 999;
    height: $search-box-height + $saerch-filter-box-height;
  }

  .search-box {
    width: 100%;
    height: $search-box-height;
    background-color: blue;
  }

  .saerch-filter-box {
    width: 100%;
    height: $saerch-filter-box-height;
    display: flex;
    flex-direction: row;
    background-color: #fff;

    li {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: $rem28;
      color: #666666;
    }

    .filter-icon {
      position: absolute;
      top: -7px;
      right: -14px;
      width: $rem26;
      height: $rem26;
      content: '';
      background-image: url('//img12.360buyimg.com/jrpmobile/jfs/t1/9350/33/2150/666/5bd13286Eefc242fe/683c6c8efdf9ea88.png');
      background-position: 0 0;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }

    .arrow-box {
      position: relative;
    }

    .arrow-trigger-event {
      position: absolute;
      width: 30px;
      height: 30px;
      top: -17px;
      left: 3px;
    }

    .arrow-all {
      position: absolute;
      left: $rem8;
      top: -$rem10;

      &.arrow-close {
        transform: rotate(180deg);
        top: -$rem2;
      }
    }

    .arrow-double-top {
      position: absolute;
      left: $rem8;
      top: -$rem18;
    }
    .arrow-double-bottom {
      position: absolute;
      left: $rem8;
      top: $rem2;
    }
    $arrowWidth: $rem8;
    .arrow-top {
      border-left: $arrowWidth transparent solid;
      border-right: $arrowWidth transparent solid;
      border-bottom: $arrowWidth #999999 solid;
      border-top: $arrowWidth transparent solid;
    }

    .arrow-bottom {
      border-bottom: $arrowWidth transparent solid;
      border-right: $arrowWidth transparent solid;
      border-top: $arrowWidth #999999 solid;
      border-left: $arrowWidth transparent solid;
    }

    .active,
    .active-1,
    .active-2 {
      color: #c29451;
      font-family: PingFangSC-Medium;
    }

    .active {
      color: #c29451;
      .arrow-top {
        border-bottom: $arrowWidth #c29451 solid;
      }
      .arrow-bottom {
        border-top: $arrowWidth #c29451 solid;
      }
    }

    .active-1 {
      .arrow-top {
        border-bottom: $arrowWidth #c29451 solid;
      }
    }

    .active-2 {
      .arrow-bottom {
        border-top: $arrowWidth #c29451 solid;
      }
    }
  }

  .search-main {
    position: relative;
    width: 100%;
    height: 100%;

    .search-main-scroll {
      padding-top: $search-box-height + $saerch-filter-box-height;
    }

    .searched-emtpy {
      padding-top: $rem106;
      text-align: center;

      img {
        width: $rem380;
        height: $rem221;
      }

      .emtpy-tips {
        margin-top: $rem66;
        font-size: $rem28;
        color: #283039;
        text-align: center;
        line-height: $rem40;
      }
    }
  }

  // .tools-fixed {
  //   position: fixed;
  //   right: $rem20;
  //   bottom: $rem132;
  //   width: $rem72;
  //   height: $rem72;
  //   z-index: 100;
  //   box-sizing: content-box;
  //   padding-bottom: constant(safe-area-inset-bottom) !important;
  //   padding-bottom: env(safe-area-inset-bottom) !important;

  //   img {
  //     width: $rem72;
  //     height: $rem72;
  //   }

  //   &.toTop {
  //     bottom: $rem40;
  //   }
  // }
}
</style>
